module.exports = __webpack_public_path__ + "static/design-9e271f605f5d69ba760b125ef3b4ccff.png";